import {
  GIANT_SQUARE_CARD_SIZE_ID,
  LARGE_SQUARE_CARD_SIZE_ID,
  SQUARE_CARD_SIZE_ID,
} from '../../../../constants'
import { Orientation } from './types'

export const getCardOrientation = ({
  isLandscape,
  variantKey,
}: {
  isLandscape: boolean
  variantKey: string
}) => {
  if (isLandscape) return Orientation.Landscape
  const isSquareCard = [
    SQUARE_CARD_SIZE_ID,
    LARGE_SQUARE_CARD_SIZE_ID,
    GIANT_SQUARE_CARD_SIZE_ID,
  ].includes(variantKey)
  if (isSquareCard) return Orientation.Square
  return Orientation.Portrait
}
